import { IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { RiskRating } from "../../../graphql/supergraphEnums";

type RiskRatingConfig = {
  iconType: IconType | null;
  color: Colors;
  label: string;
};

export const RISK_RATING_CONFIG: Record<RiskRating, RiskRatingConfig> = {
  [RiskRating.Low]: {
    iconType: "gauge-simple-low",
    color: Colors.Success600,
    label: "Low risk",
  },
  [RiskRating.Medium]: {
    iconType: "gauge-simple-med",
    color: Colors.Success600,
    label: "Medium risk",
  },
  [RiskRating.High]: {
    iconType: "gauge-simple-high",
    color: Colors.Danger600,
    label: "High risk",
  },
  [RiskRating.Halt]: {
    iconType: "gauge-simple-max",
    color: Colors.Danger600,
    label: "Halt",
  },
  [RiskRating.None]: {
    iconType: null,
    color: Colors.Neutral999,
    label: "N/A",
  },
};
